import React from 'react';

interface SkeletonProps extends React.HTMLAttributes<HTMLDivElement> {
  variant?: 'text' | 'circle' | 'rect';
  width?: number | string;
  height?: number | string;
}

export const Skeleton: React.FC<SkeletonProps> = ({ variant = 'rect', width, height, className = '', style, ...rest }) => {
  const baseClass = 'animate-pulse bg-slate-200 dark:bg-slate-800';
  const radius =
    variant === 'circle' ? 'rounded-full' :
    variant === 'text' ? 'rounded-md' : 'rounded-lg';

  const styleProps: React.CSSProperties = {
    width: width ?? (variant === 'text' ? '100%' : undefined),
    height: height ?? (variant === 'text' ? '0.9em' : undefined),
    ...style,
  };

  return <div className={`${baseClass} ${radius} ${className}`} style={styleProps} {...rest} />;
};

// Convenience: skeleton block for card/list loading states
interface SkeletonGroupProps {
  rows?: number;
  className?: string;
}

export const SkeletonGroup: React.FC<SkeletonGroupProps> = ({ rows = 3, className = '' }) => {
  return (
    <div className={`space-y-3 ${className}`}>
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} className="flex items-center gap-3">
          <Skeleton variant="circle" width={40} height={40} />
          <div className="flex-1 space-y-2">
            <Skeleton variant="text" width="50%" height={14} />
            <Skeleton variant="text" width="30%" height={10} />
          </div>
        </div>
      ))}
    </div>
  );
};
